import * as constants from '@/common/constants';
import { get, post, put, del } from '@/utils/http';

/** 获取用户任务列表 */
export const getProcessTaskList = (params) => {
    return post(constants.API_PROCESS_TASK_LIST, params);
};
/** 获取用户任务列表 */
export const addTaskUserRemark = (params) => {
    return post(constants.API_PROCESS_TASK_ADDTASKUSERREMARK, params);
};
/** 获取用户任务列表 */
export const updateTaskUserRemark = (params) => {
    return post(constants.API_PROCESS_TASK_UPDATETASKUSERREMARK, params);
};

/** 获取任务详情 */
export const getProcessTaskDetail = (taskId) => {
    return new Promise((resolve, reject) => {
        get(constants.API_PROCESS_TASK_DETAIL.replace(':taskId', taskId)).then(res => {
            try {
                if (res && res.hasOwnProperty('formObj')) {
                    res.formObj.structure.forEach((item1, index1) => {
                        item1.fieldsList.forEach((item2, index2) => {
                            res.formObj.structure[index1].fieldsList[index2].formField = item2.id;
                        });
                    });
                }
            } catch (error) {
                reject(error);
            }
            resolve(res);
        }).catch(err => {
            reject(err);
        });
    });
    // return get(constants.API_PROCESS_TASK_DETAIL.replace(':taskId', taskId));
};

/** 认领任务 */
export const processTaskClaim = (taskId) => {
    return put(constants.API_PROCESS_TASK_CLAIM.replace(':taskId', taskId));
};

/** 任务完成 */
export const processTaskComplete = (taskData) => {
    return post(constants.API_PROCESS_TASK_COMPLETE.replace(':taskId', taskData.taskId), taskData);
};

/** 任务回退 */
export const processTaskRevoke = (taskData) => {
    return post(constants.API_PROCESS_TASK_REVOKETASK.replace(':taskId', taskData.taskId), taskData);
};

/** 获取下一任务list */
export const getNextTaskNodeList = (taskData) => {
    return post(constants.API_PROCESS_TASK_NEXT_TASK_NODE_LIST, taskData);
};

/** 删除任务 */
export const processTaskDelete = (processInstanceId, taskId) => {
    return del(constants.API_PROCESS_TASK_DELETE.replace(':processInstanceId', processInstanceId).replace(':taskId', taskId));
};

/** 隐藏任务 */
export const processTaskHidden = (param) => {
    return post(constants.API_PROCESS_TASK_HIDDEN, param);
};

/** 任务暂时保存 */
export const processTaskTemporarySave = (taskData) => {
    return post(constants.API_PROCESS_TASK_TEMPORARY_SAVE.replace(':taskId', taskData.taskId), taskData);
};

export const getProcessTaskCommentList = (params) => {
    return get(constants.API_PROCESS_TASK_COMMENT_LIST, params);
};

export const saveProcessTaskComment = (params) => {
    return post(constants.API_PROCESS_TASK_COMMENT_SAVE, params);
};

export const deleteProcessTaskComment = (commentId) => {
    return del(constants.API_PROCESS_TASK_COMMENT_DELETE.replace(':commentId', commentId));
};

// export const getProcessTaskFiles = (taskId) => {
//     return get(constants.API_PROCESS_TASK_GET_FILES, {
//         taskId: taskId,
//         currentPage: 1,
//         pageSize: 50
//     });
// };
export const getProcessTaskFiles = (params) => {
    return get(constants.API_PROCESS_TASK_GET_FILES, params);
};
export const delTaskFile = (params) => {
    return post(constants.API_PROCESS_TASK_DELETE_FILE, params);
};

export const involveUser = (params) => {
    return post(constants.API_PROCESS_TASK_INVOLVEUSER, params);
};

export const transferAssignee = (params) => {
    return post(constants.API_PROCESS_TASK_TRANSFERASSIGNEE, params);
};

export const interveneProcessTaskConfig = (element) => {
    return post(constants.API_PROCESS_TASK_INTERVENE_SAVE, element);
};

export const batchChangeTaskAssigneeUser = (param) => {
    return post(constants.API_PROCESS_TASK_BATCH_CHANGE_TASK_ASSIGNEE_USER, param);
};

export const saveTags = (params) => {
    return post(constants.API_PROCESS_TASK_SAVE_TAGS, params);
};

export const saveArchiveTreeFileRelation = (params) => {
    return post(constants.API_PROCESS_TASK_SAVE_ARCHIVE_TREE_FILE_RELATION, params);
};

/** 流程任务文件共享给主流程可见 */
export const addProcessFileShare = (fileBO) => {
    return post(constants.API_PROCESS_TASK_FILE_SHARE_ADD, fileBO);
};

/** 取消流程任务文件共享给主流程可见 */
export const delProcessFileShare = (fileId, processInstanceId) => {
    return del(constants.API_PROCESS_TASK_FILE_SHARE_DEL.replace(':fileId', fileId).replace(':processInstanceId', processInstanceId));
};

/** 获取当前任务管理的审批流模板list */
export const getApprovalTemplateBOListByTaskId = (taskData) => {
    return post(constants.API_PROCESS_TASK_APPROVL_TEMPLATE_LIST_BY_TASKID, taskData);
};

/** 动态新增会签任务节点(并行) */
export const addMutilTask = (param) => {
    return post(constants.API_PROCESS_TASK_MUTIL_ADD, param);
};

/** 动态删除会签任务节点(并行) */
export const deleteMutilTask = (processInstanceId, taskId) => {
    return del(constants.API_PROCESS_TASK_MUTIL_DELETE.replace(':processInstanceId', processInstanceId).replace(':taskId', taskId));
};

/** 获取进行中的任务列表 */
export const getDoingTaskList = (params) => {
    return post(constants.API_PROCESS_TASK_DOING_LIST, params);
};

/** 查询流程中指定任务的对应数据主键 */
export const getProcessInstanceTaskPkId = (params) => {
    return post(constants.API_PROCESS_TASK_INSTANCE_PKID, params);
};

/** 获取任务完成记录 */
export const getTaskInstanceExecuteRecordBOList = (params) => {
    return post(constants.API_PROCESS_TASKINSTANCE_EXECUTE_RECORD_LIST, params);
};

/** 查询流程中指定任务的会签表单的表单实例ID */
export const getTeamWorkModelInstanceId = (params) => {
    return get(constants.API_PROCESS_TASK_TEAMWORK_MODEL_INSTANCEID, params);
};

/** 查询流程中指定任务的会签表单的表单实例ID */
export const isTeamWorkModelFirstTaskForm = (params) => {
    return get(constants.API_PROCESS_TASK_IS_TEAMWORK_FIRST_TASK_FORM, params);
};

/** 查询流程中指定任务的会签表单的表单实例ID */
export const getLastProcessTaskFormData = (params) => {
    return get(constants.API_PROCESS_TASK_LAST_PROCESS_TASK_FORM_DATA, params);
};

export const getRefHisProcessData = (params) => {
    return get(constants.API_PROCESS_TASK_GET_REF_HIS_PROCESS_DATA, params);
};

export const deleteProcessInstanceUserForced = (params) => {
    return post(constants.API_PROCESS_TASK_DELETE_PROCESS_USER, params);
};



// WEBPACK FOOTER //
// ./src/data-model/process/task-model.js